module.exports = "header {\n    background: url('bg-header-red.09f778b2315b2400f4ee.jpg');\n}\n.groups {\n    \n    padding: 25px 0;\n}\n.flag {\n    float: left;\n    margin:5px;\n}\n.flag img{\n    width: 70px;\n}\n.lgi-text {\n    font-size: 24px;\n    line-height: 2em;\n}\nheader h1 {\n    color:rgba(247, 240, 215, 0.906);\n    line-height: 2em;\n    font-size: 40px;\n    text-shadow: 0px 2px 10px #FFF;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/groups/groups.component.css
// module id = ./src/app/components/groups/groups.component.css
// module chunks = main